/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { postRequest, putRequest } from 'src/utils/RequestUtil';

export const catalogueSearchAPI = function (data) {
    const url = `${config.baseUrl}catalogue/search`;
    return postRequest({
        url,
        data,
    });
};

export const catalogueCreateAPI = function (data) {
    const url = `${config.baseUrl}catalogue`;
    return postRequest({
        url,
        data,
    });
};

export const catalogueUpdateAPI = function ({
    catalogueId,
    data,
}) {
    const url = `${config.baseUrl}catalogue/${catalogueId}`;
    return putRequest({
        url,
        data,
    });
};
